import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button/button.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { MobileModalWindowComponent } from './mobile-modal-window.component';

@NgModule({
  declarations: [MobileModalWindowComponent],
  imports: [CommonModule, ButtonModule, SvgIconModule],
  exports: [MobileModalWindowComponent]
})
export class MobileModalWindowModule {}

export * from './mobile-modal-window.component';
